var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item small",on:{"click":function($event){return _vm.$emit('selected', _vm.value)}}},[_c('a',{staticClass:"nav-link",class:{ active: _vm.value === _vm.selected }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }